export default "__VITE_ASSET__DsskJ4g0__"